import React from 'react'
import styled from 'styled-components'

const Slider = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.forecast.background3};
  transition: 0.2s;
  border-radius: 24px;
  pointer-events: none;
  z-index: 1;

  &:before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.2s;
    border-radius: 50%;
  }
`

const StyledSwitch = styled.label`
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  cursor: pointer;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    cursor: pointer;
    z-index: 2;
  }

  input:checked + ${Slider} {
    background-color: ${({ theme }) =>
      theme.forecast.primary ?? theme.forecast.defaultButton};
  }

  input:checked + ${Slider}:before {
    transform: translateX(20px);
  }

  &:hover ${Slider} {
    background-color: ${({ theme }) => theme.forecast.background4};
  }

  input:checked ~ ${Slider}, input:checked:hover ~ ${Slider} {
    background-color: ${({ theme }) =>
      theme.forecast.primary ?? theme.forecast.defaultButton};
    opacity: 0.9;
  }
`

interface SlideToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  ariaLabel: string
}

export const SlideToggle: React.FC<SlideToggleProps> = ({
  checked,
  onChange,
  ariaLabel,
}) => {
  return (
    <StyledSwitch>
      <input
        type='checkbox'
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        aria-label={ariaLabel}
      />
      <Slider />
    </StyledSwitch>
  )
}
